import { RoutesGroup } from '@/const';
import routes from './routes';

export default {
    routes,
    group: RoutesGroup.Configurazione,
    moduleName: "Ricettario"
};